import Footer from "components/Footer";
import Header from "components/Header";
import React from "react";
import styled from "styled-components";

const ContainerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ChildrenWrapper = styled.div`
  /* margin: 0 72px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 24px;
  `} */
`;
interface GlobalContainer {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

function Container(props: GlobalContainer): JSX.Element {
  const { children } = props;
  return (
    <ContainerWrapper>
      <Header />
      <ChildrenWrapper style={props.style}>{children}</ChildrenWrapper>
      <Footer />
    </ContainerWrapper>
  );
}

export default Container;
